import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';

interface IWaiteItem {
  isChatList?: boolean;
}

const WaitItem = ({ isChatList = true }: IWaiteItem) => {
  return (
    <div css={waitContainer(isChatList)}>
      <div className="container">
        <div className="point"></div>
        <div className="point delay-second"></div>
        <div className="point delay-third"></div>
      </div>
    </div>
  );
};

const waitContainer = (isChatList: boolean) => css`
  height: 2.5em;
  width: 100%;
  display: flex;
  justify-content: ${isChatList ? 'flex-end' : 'center'};
  margin: 1em 0;

  .container {
    width: ${isChatList ? '100px' : '100%'};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: ${isChatList ? `1px solid ${theme.colors.gray400}` : `none`};
    border-radius: 8px;
    gap: 0.8em;
    margin-right: ${isChatList ? '4em' : '0'};
  }

  .point {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    background-color: ${theme.colors.gray400};
    animation: waitItemFadeIn 1.5s;
    animation-iteration-count: infinite;
  }

  .delay-second {
    animation-delay: 0.5s;
  }

  .delay-third {
    animation-delay: 1s;
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    .container {
      width: 70px;
    }

    .point {
      width: 9px;
      height: 9px;
    }
  }

  @keyframes waitItemFadeIn {
    0% {
      background-color: ${theme.colors.gray700};
    }
    50% {
      background-color: ${theme.colors.gray400};
    }
    100% {
      background-color: ${theme.colors.gray400};
    }
  }
`;

export default WaitItem;
